/**
 * @generated SignedSource<<7f78672e5e726d990741d6140b5a8c6c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedRelatedItemsSection_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_itemSearch" | "useSbSharedItemTracking_itemSearch">;
  readonly " $fragmentType": "SharedRelatedItemsSection_itemSearch";
};
export type SharedRelatedItemsSection_itemSearch$key = {
  readonly " $data"?: SharedRelatedItemsSection_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRelatedItemsSection_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedRelatedItemsSection_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSbSharedItemTracking_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "d2754c09b542d55f54255e442659f02b";

export default node;
